import { Link } from "react-router-dom";
import { Tag, Facebook } from "lucide-react";

const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61591387327921";

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <span className="grid place-items-center w-8 h-8 rounded-lg bg-emerald-600 text-white"><Tag size={16} strokeWidth={2.5} /></span>
            <span className="font-heading font-extrabold text-lg text-slate-900">Deal<span className="text-emerald-600">Shed</span></span>
          </Link>
          <p className="text-sm text-slate-500 mt-3">Ireland's friendly marketplace for pretty much everything, from motors to machinery.</p>
          <div className="mt-4 flex items-center gap-2">
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="DealShed on Facebook" data-testid="footer-facebook-link"
              className="grid place-items-center w-9 h-9 rounded-full bg-white border border-slate-200 text-slate-600 hover:text-white hover:bg-[#1877F2] hover:border-[#1877F2] transition-colors">
              <Facebook size={18} />
            </a>
          </div>
        </div>
        {[
          { h: "Categories", items: [
            { label: "Motors", to: "/category/motors" },
            { label: "Jobs", to: "/category/jobs" },
            { label: "House & DIY", to: "/category/house-diy" },
            { label: "Farming", to: "/category/farming" },
          ] },
          { h: "Company", items: [
            { label: "About Us", to: "/about" },
          ] },
          { h: "Support", items: [
            { label: "Safety Advice", to: "/safety" },
            { label: "Terms", to: "/terms" },
            { label: "Privacy", to: "/privacy" },
            { label: "Cookies", to: "/cookies" },
          ] },
        ].map((col) => (
          <div key={col.h}>
            <p className="text-xs uppercase tracking-wider font-semibold text-slate-500 mb-3">{col.h}</p>
            <ul className="space-y-2">
              {col.items.map((i) => <li key={i.label}><Link to={i.to} className="text-sm text-slate-600 hover:text-emerald-600">{i.label}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-400">© 2026 DealShed. All rights reserved.</div>
    </footer>
  );
}
